import type { Permission, Permissions } from 'api/types';

type HasRequiredPermissionArgs = {
  userPermissions: Permissions;
  // A list grants access when the user has ANY of the listed permissions.
  requiredPermissions?: Permission | Permission[];
};

export const hasRequiredPermission = ({ userPermissions, requiredPermissions }: HasRequiredPermissionArgs) => {
  if (!requiredPermissions) {
    return true;
  }

  if (Array.isArray(requiredPermissions)) {
    return requiredPermissions.some((item) => userPermissions.has(item));
  }

  return userPermissions.has(requiredPermissions);
};
